import makeAsyncSearch from '../modules/async-search'

const searchInput = document.getElementById('id-header-search')
const searchInputContainer = searchInput ? searchInput.parentNode : undefined
const searchPopup = document.querySelector('.j-search-popup')

const filtersWrapper = document.getElementById('id-search-popup')
const searchPopupGrid = document.getElementById('id-search-popup-grid')

const asyncSearchCallback = (res, flush = false) => {
	// when reiniting, bail out of everything
	if (flush) {
		return flushPopup()
	}

	if (res) {
		filtersWrapper.innerHTML = res.data.html
		searchPopup.classList.remove('is-loading')
		asyncSearch.reinit()
	} else {
		searchPopup.classList.add('is-loading')
	}
}

const asyncSearch = makeAsyncSearch()
asyncSearch.init({
	searchInput,
	// filterInputs,
	callback: asyncSearchCallback,
})

const focusOnSearch = () => {
	searchInput.addEventListener('focus', function () {
		searchInputContainer.classList.add('is-focused')
		// open search popup
		searchPopup.classList.add('is-active')
		document.body.classList.add('has-searchpopup-open')
	})
	searchInput.addEventListener('blur', function () {
		searchInputContainer.classList.remove('is-focused')
	})
}

//
const flushPopup = () => {
	if(searchPopupGrid){
		searchPopupGrid.innerHTML = ''
	}
	searchInput.blur()
	searchPopup.classList.remove('is-active')
	searchPopup.classList.add('is-loading')
}

// Close menu when the user clicks outside it
const closeSearchPopup = () => {
	document.addEventListener('click', (e) => {
		if (searchPopup.classList.contains('is-active')) {
			// click outside of searchPopup and outside of search input
			if (!searchPopup.contains(e.target) && !searchInput.contains(e.target)) {
				filtersWrapper.classList.remove('is-active')
				document.body.classList.remove('has-searchpopup-open')
			}
		}
	})
}

if (searchInput) {
	focusOnSearch()
	// toggleFocusBasedOnFilters()
	closeSearchPopup()
}
